import { Box, Container, Heading, Text, Image } from '@everlywell/ui-kit';
import React from 'react';
import { IContentWithImage } from 'utils/types';

interface StatsWithImagesProps {
  headline: string;
  description: {
    description: string;
  };
  listOfContentWithImages: IContentWithImage[];
}

const StatsWithImages: React.FC<StatsWithImagesProps> = ({
  headline,
  description,
  listOfContentWithImages,
}) => {
  const coloredHeadline = headline.split(' ').map((word, index) => (
    <span
      key={index}
      style={{
        color: word === '25+' ? '#FF6B6B' : 'inherit',
        marginRight: '0.5rem',
      }}
    >
      {word}
    </span>
  ));

  return (
    <Container size="xl" pb={['3rem', '5rem', '5rem']} pt="1rem" mx="auto">
      <Box textAlign="center" marginBottom={16}>
        <Heading as="h2" size="2xl" color="black" marginBottom={3}>
          {coloredHeadline}
        </Heading>

        <Text size="lg" color="#545454" maxWidth="800px" mx="auto">
          {description.description}
        </Text>
      </Box>

      <Box display="flex" flexDirection="column" gap={[8, 8, 12]}>
        {listOfContentWithImages.map((content, index) => {
          const isEven = index % 2 === 0;

          const coloredHeading = content.heading?.split('').map((char, idx) => (
            <span
              key={idx}
              style={{
                color: char === '+' ? '#FF6B6B' : 'inherit',
                fontSize: char === '+' ? '2rem' : 'inherit',
              }}
            >
              {char}
            </span>
          ));

          return (
            <Box
              key={index}
              display="flex"
              flexDirection={['column', 'row', 'row']}
              alignItems="center"
              justifyContent="center"
              gap={[6, 8, 8]}
            >
              <Box
                order={[0, null, isEven ? 0 : 1]}
                flex="1"
                width="100%"
                role="img"
                aria-label={content.image?.title || 'Statistics illustration'}
              >
                <Image
                  src={content.image?.url}
                  alt={content.image?.title || ''}
                  width="100%"
                  height="auto"
                  borderRadius="lg"
                  objectFit="cover"
                />
              </Box>

              <Box
                order={[1, null, isEven ? 1 : 0]}
                flex="1"
                transform={['none', 'translateX(2rem)', 'translateX(4rem)']}
              >
                <Heading
                  as="h3"
                  size="3xl"
                  color="black"
                  marginBottom={3}
                  textTransform="uppercase"
                >
                  {coloredHeading}
                </Heading>
                <Text color="#545454" size="md" maxWidth="360px">
                  {content.description.description}
                </Text>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Container>
  );
};

export default StatsWithImages;
